import { sanitizeNotificationHtml } from '../../utils/sanitizeHtml';

export default {
    props: {
        variant: {
            type: String,
            default: 'primary',
        },
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        html: {
            type: Boolean,
            default: false,
        },
        hideClose: {
            type: Boolean,
            default: false,
        },
    },
    template: `
  <div class="toastification">
    <div :class="'d-flex align-items-start'">
      <a href="#" style="font-size: 1.8rem" :class="'me-75 flex-shrink-0 text-' + variant"><i :class="'feather ' + icon"></i></a>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="'text-' + variant"
            v-text="title"
          />
          <small
            v-if="text && html"
            class="d-inline-block text-body toastification-html"
            v-html="sanitizeNotificationHtml(text)"
          />
          <small
            v-else-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ms-auto"
          @click="$emit('close-toast')"
        >
          <i :class="'feather ' + icon"></i>
        </span>
      </div>
    </div>
  </div>
  `,
    methods: {
        sanitizeNotificationHtml,
    },
};
